<template>
    <BaseCard
        class="pt-9 pb-11 text-center"
        data-spec-class="teaser-card"
    >
        <BaseCardTitle class="mb-4 flex items-center justify-center !text-xl">
            <slot name="title">
                <span>{{ title }}</span>
                <BaseTooltipHelp v-if="tooltip">{{ tooltip }}</BaseTooltipHelp>
            </slot>
        </BaseCardTitle>

        <BaseCardContent class="mx-8 !text-base">
            <slot />
        </BaseCardContent>

        <div
            v-if="!!$slots.actions"
            class="mt-5"
        >
            <slot name="actions" />
        </div>
    </BaseCard>
</template>

<script lang="ts" setup>
import { Size } from '@/types';
import BaseTooltipHelp from './BaseTooltipHelp.vue';

interface Props {
    title: string;
    tooltip?: string;
    size?: Size;
}

withDefaults(defineProps<Props>(), {
    size: Size.Normal,
    tooltip: undefined,
});
</script>
